<template>
  <div v-if="data != '' && data != null" class="text" >
    <div class="box" v-html="this.highlightedText" v-if="!editing" @click.shift="handleClick"></div>
    <div v-if="editing" >
      <textarea ref="textarea" class="editing-text-area" v-model="editingText"></textarea>
      <button @click="handleSaveEdit" class="button" style="margin-top: 5px;">Save</button>
      <button @click="handleCancelEdit" class="button" style="margin-top: 5px;">Cancel</button>
    </div>
  </div>
</template>

<script>

  import { mapState, mapMutations } from 'vuex'
  import jsEwts from '../jsewts'
  import Vue from "vue";

  export default {
  name: 'Result',
  props: {
    data: [String, Number],
    title: String,
    columnName: String,
    largerFont: false
  },
    data() {
      return {
        editing: false,
        editingText: this.data,
        text: this.data
      }
    },
  computed: {
    ...mapState('app', [
      'searchText',
      'searchType',
      'allowEdits',
      'editToken',
      'editInProcess'
    ]),
    highlightedText() {
      const replaceNewlines = this.processNewLines(this.text);
      const replaceWylie = replaceNewlines.replace(/{([^}]*)}/g, (match) => {
        return '<span class="tibetan-result-verbinator">'+jsEwts.toUnicode(match.replace(/[{}]/g, ''), '')+"</span>";
      })
      return replaceWylie;
    }
  },
  methods: {
    ...mapMutations([
      'setEditInProcess',
    ]),
    processNewLines(input) {
      // eslint-disable-next-line no-control-regex
      return input.replace(/\n|\\n/g, "<br/>").replace(/།་/g, "། " );
    },
    handleClick() {
      if (this.allowEdits) {
        if (this.editInProcess) {
          alert("Finish open edit before trying to edit another value")
          return
        }
        this.setEditInProcess(true);
        this.editing = true;
        this.editingText = this.text.replace(/\\n/gm, "\n")
        Vue.nextTick( () => {
          this.resizeTextArea();
        });
      }
    },
    async handleSaveEdit() {
      this.text = this.editingText;
      await this.saveEdit();
      this.setEditInProcess(false);
    },
    handleCancelEdit() {
      this.editing = false;
      this.setEditInProcess(false);
    },
    resizeTextArea() {
      const { textarea } = this.$refs;
      textarea.style.height = textarea.scrollHeight + 10 + 'px';
    },
    async saveEdit() {
      // eslint-disable-next-line no-console
      this.$log.debug(`Editing id=${this.entryId}, column = ${this.columnName} new value = "${this.text}"`)
      const newValue = this.text
      await this.$server.dictionaryService.patch(this.entryId, {
        value:newValue,
        columnName:this.columnName,
        comment:"",
        user: "",
        entryId: this.entryId,
        token: this.editToken
      });
      this.editing = false;
    },
  }
}
</script>

<style>
.tibetan-result-verbinator {
  font-size: 140%;
  line-height: 80%;
}
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  .result-title {
    font-weight: bold;
    margin-right:5px;
  }

  .largerfont {
    font-size: 160% !important;
    line-height: 80%;
  }

  .box {
    border-radius: 10px;
    background-color: #f9f9f9;
    padding: 10px;
  }

  .editing-text-area {
    width: 100%;
  }


  .button {

    border: 0;
    outline: 0;
    cursor: pointer;
    color: rgb(60, 66, 87);
    background-color: transparent;
    box-shadow: rgb(0 0 0 / 0%) 0px 0px 0px 0px, rgb(0 0 0 / 0%) 0px 0px 0px 0px, rgb(0 0 0 / 12%) 0px 1px 1px 0px, rgb(60 66 87 / 16%) 0px 0px 0px 1px, rgb(0 0 0 / 0%) 0px 0px 0px 0px, rgb(0 0 0 / 0%) 0px 0px 0px 0px, rgb(60 66 87 / 8%) 0px 2px 5px 0px;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 500;
    padding: 4px 8px;
    display: inline-block;
    min-height: 28px;
    transition: background-color .24s,box-shadow .24s;
  }

  .add-note-button {
    border: 0;
    outline: 0;
    cursor: pointer;
    color: rgb(60, 66, 87);
    background-color: transparent;
    box-shadow: rgb(0 0 0 / 0%) 0px 0px 0px 0px, rgb(0 0 0 / 0%) 0px 0px 0px 0px, rgb(0 0 0 / 12%) 0px 1px 1px 0px, rgb(60 66 87 / 16%) 0px 0px 0px 1px, rgb(0 0 0 / 0%) 0px 0px 0px 0px, rgb(0 0 0 / 0%) 0px 0px 0px 0px, rgb(60 66 87 / 8%) 0px 2px 5px 0px;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 500;
    padding: 4px 8px;
    display: inline-block;
    min-height: 28px;
    transition: background-color .24s,box-shadow .24s;
  }

  button:hover {
    box-shadow: rgb(0 0 0 / 0%) 0px 0px 0px 0px, rgb(0 0 0 / 0%) 0px 0px 0px 0px, rgb(0 0 0 / 12%) 0px 1px 1px 0px, rgb(60 66 87 / 16%) 0px 0px 0px 1px, rgb(0 0 0 / 0%) 0px 0px 0px 0px, rgb(60 66 87 / 8%) 0px 3px 9px 0px, rgb(60 66 87 / 8%) 0px 2px 5px 0px;
  }
</style>
